export const SHOP_TITLE_UPDATE = 'SHOP_TITLE_UPDATE';
export const SHOP_LAYOUT_UPDATE = 'SHOP_LAYOUT_UPDATE';
